import React from 'react';
import LoggedInPage from '../../views/core/LoggedInPage';


export default class SubscribeModal extends LoggedInPage{
	
	constructor(props) {
		super(props);
    }
    
	render(){
		return(
			<div id="ss-modal-bdy">
				<div>
					<h2><span>
                    <i className="material-icons md-50 playicon upgrdlock1">lock</i>
                        </span></h2>
				</div>
				<div>
                        <h1>{this.rb("upgrade.heading")}</h1>
                        <p>{this.rb("upgrade.description")}</p>
				</div>
				<div className="subscrbtn">
                { this.subscribeFn(this.props.ga)}
				</div>
			</div>
		)
	}

}


// WEBPACK FOOTER //
// ./src/views/plp/SubscribeModal.js